import { useState, useEffect } from 'react';

import {
  setItemInStorage,
  getItemFromStorage,
  removeItemInStorage,
} from 'commons/localStorage';
import usePDPOptions from 'components/consumer/PDP/state/context/usePDPOptions';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useCart from '../useCart';
import { PDP_EXTRA_CUSHION } from '../../commons/constants';

const usePDPExtraCushion = () => {
  // hooks
  const { loading, error, data: productDetails } = usePDPBasicDetails();

  const {
    loading: optionsLoading,
    error: optionsError,
    data: optionsData,
  } = usePDPOptions();

  const {
    loading: cartLoading,
    data: { cart },
  } = useCart();

  // state
  const [priceObj, setPriceObj] = useState({});
  const [isAdded, setIsAdded] = useState(false);
  const [optionValueId, setOptionValueId] = useState(false);

  // effects
  useEffect(() => {
    const getItem = () => {
      if (productDetails?.id) {
        return getItemFromStorage(`${PDP_EXTRA_CUSHION}:${productDetails.id}`);
      }
      return null;
    };

    if (!productDetails?.id || !optionsData?.options) return;

    let cost = 0;
    let valueId;
    const cushion = optionsData?.options.find(o => o.id === 133);

    if (cushion?.values) {
      cushion.values.forEach(v => {
        if (v.additional_cost > 0) {
          valueId = v.id;
          cost = v.additional_cost;
        }
      });
      const priceObjCopy = { ...productDetails?.meta?.price };
      priceObjCopy.original_price = cost;

      if (cost) setPriceObj(priceObjCopy);
      if (valueId) setOptionValueId(valueId);
    }

    if (getItem()) {
      setIsAdded(true);
    }
  }, [optionsData?.options, productDetails?.id, productDetails?.meta?.price]);

  useEffect(() => {
    const getItem = () => {
      if (productDetails?.id) {
        return getItemFromStorage(`${PDP_EXTRA_CUSHION}:${productDetails.id}`);
      }
      return null;
    };
    if (!cartLoading) {
      setIsAdded(!!getItem());
    }
  }, [cart, cartLoading, productDetails?.id]);

  // actions
  const setItem = val => {
    if (productDetails?.id)
      setItemInStorage(`${PDP_EXTRA_CUSHION}:${productDetails.id}`, val);
  };

  const removeItem = () => {
    if (productDetails?.id)
      removeItemInStorage(`${PDP_EXTRA_CUSHION}:${productDetails.id}`);
  };

  const onAdd = () => {
    setItem(optionValueId);
    setIsAdded(true);
  };

  const onRemove = () => {
    removeItem();
    setIsAdded(false);
  };

  return {
    loading: loading || optionsLoading,
    error: error || optionsError,
    data: {
      priceObj,
      promotion: productDetails?.meta?.promotion,
      isAdded,
    },
    actions: {
      onAdd,
      onRemove,
    },
  };
};

export default usePDPExtraCushion;
